function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.768 10l4.066-4.067-1.768-1.768L10 8.231 5.934 4.165 4.166 5.933 8.232 10l-4.066 4.066 1.768 1.768L10 11.767l4.066 4.066 1.768-1.768-4.066-4.066z",
  fill: "currentColor"
});

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjc2NzggOS45OTkxMUwxNS44MzM2IDUuOTMzMjVMMTQuMDY1OSA0LjE2NTQ4TDEwIDguMjMxMzRMNS45MzQxNCA0LjE2NTQ3TDQuMTY2MzggNS45MzMyM0w4LjIzMjI1IDkuOTk5MUw0LjE2NjQgMTQuMDY1TDUuOTM0MTUgMTUuODMyN0wxMCAxMS43NjY5TDE0LjA2NTkgMTUuODMyN0wxNS44MzM2IDE0LjA2NUwxMS43Njc4IDkuOTk5MTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgCross as ReactComponent };